import React, { useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../../../../models";
import classNames from "classnames";
import settingsStyles from "../../../../../../styles/settings.css";
import { TextButton } from "../../../../../textButton/textButton";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { MessageWidgets } from "../../types";
import { MessageWidgetList } from "../formName/messageWidgetList";
import { MessageWidgetPicker } from "../messageWidgetPicker/messageWidgetPicker";
import { handleMessageWidgetDelete, handleMessageWidgetPick } from "../../utils";
import { NO_TAG_GROUP_ID } from "../../../../../../models/messageWidgets/TagGroupMessageWidgetsMap";

interface Props {
  groupId: string;
  messageWidgets: MessageWidgets;
}

export const GroupActionsInput = observer(({ messageWidgets }: Props) => {
  const [initialPicked] = useState([...messageWidgets.$.picked]);

  const { messageWidgetsStore } = useStore();
  const [isPicking, setIsPicking] = useState(false);
  const availableWidget = messageWidgetsStore.getOnlyAssignedWidgets(NO_TAG_GROUP_ID);

  const availableToPick = [...availableWidget, ...initialPicked].filter(
    ({ id }) => !messageWidgets.$.picked.find((el) => el.id === id)
  );

  const onDelete = (idToDelete: string) => {
    messageWidgets.reset(
      handleMessageWidgetDelete(messageWidgets.$.picked, initialPicked, idToDelete)
    );
  };

  const renderInput = () =>
    isPicking ? (
      <MessageWidgetPicker
        onOutsideClick={() => setIsPicking(!messageWidgets.$.picked)}
        className={classNames(
          !!messageWidgets.$.picked.length && settingsStyles["list-margin"],
          settingsStyles["input-width-bigger"]
        )}
        onChange={(messageWidget) => {
          messageWidgets.reset(
            handleMessageWidgetPick(messageWidgets.$.picked, initialPicked, messageWidget)
          );
          setIsPicking(false);
        }}
        items={availableToPick}
        error={messageWidgets.error}
        initialIsOpen
        onStateChange={(_, state) => (!state.isOpen ? setIsPicking(false) : undefined)}
      />
    ) : (
      <TextButton
        text={"+ " + intl.formatMessage("settings.tagGroups.form.messageWidgets.button")}
        className={settingsStyles["list-margin"]}
        onClick={() => setIsPicking(true)}
      />
    );

  return (
    <div>
      {Boolean(messageWidgets.$.picked.length) && (
        <MessageWidgetList messageWidget={messageWidgets.$.picked} onActionDelete={onDelete} />
      )}
      {Boolean(availableWidget.length) && renderInput()}
    </div>
  );
});
